import { useModuleBEM } from "@b2bportal/core-themes";
import type { HotelSortOptionEnum } from "@b2bportal/core-types";
import { useHotelListSort } from "@tenant/hotels";
import { RadioGroup } from "@tenant/ui";
import styles from "./FilterListSort.module.scss";

type FilterListSortProps = {
  selectedSort: HotelSortOptionEnum;
  onChange: (value: HotelSortOptionEnum) => void;
};

export const FilterListSort = ({
  selectedSort,
  onChange,
}: FilterListSortProps) => {
  const [block, cn] = useModuleBEM(styles, "FilterListSort");

  const {
    context: { sortOptions },
  } = useHotelListSort();

  return (
    <div className={block}>
      <RadioGroup
        className={cn("radio-group")}
        selectedOption={selectedSort}
        onSelectValue={onChange}
        options={sortOptions}
      />
    </div>
  );
};
